import { DependencyContainer } from '../../../DependencyContainer';
import { Maybe } from '../../../types';
import { OutreachTypes } from '../../../urls';
import { OutreachMetadata } from '../types';

export default class MetadataService {
  constructor(private readonly factory: DependencyContainer) {}

  async getMetadata(): Promise<Maybe<any>> {
    const response = await this.factory.metadataClient.fetchMetadata();
    return response.data;
  }

  async getAllowedValues(
    partnerId: string,
    columnName: string,
  ): Promise<Maybe<string[]>> {
    const response = await this.factory.metadataClient.fetchAllowedValues(
      partnerId,
      columnName,
    );
    return response.data;
  }

  async getOutreachMetadata(
    partnerId: string,
    monitorId: string,
  ): Promise<OutreachMetadata> {
    const metadataForEmail = await this.factory.metadataClient.fetchOutreachMetadata(
      partnerId,
      monitorId,
      OutreachTypes.Email,
    );
    const metadataForPush = await this.factory.metadataClient.fetchOutreachMetadata(
      partnerId,
      monitorId,
      OutreachTypes.Push,
    );
    const metadataForWebhook = await this.factory.metadataClient.fetchOutreachMetadata(
      partnerId,
      monitorId,
      OutreachTypes.Webhooks,
    );
    return {
      [OutreachTypes.Email]: metadataForEmail,
      [OutreachTypes.Push]: metadataForPush,
      [OutreachTypes.Webhooks]: metadataForWebhook,
    };
  }
}
